module.exports = __webpack_public_path__ + "static/media/64.f1d4b8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/64.png
// module id = 638
// module chunks = 0